import axios from 'axios';
import { APIResponse, PaymentData, PaymentSocketData } from './PayClasses';

const ROOT_URL = process.env.REACT_APP_API_URL+'/public'
export const CDN_URL = process.env.REACT_APP_CDN_URL;
const DEBUG = process.env.REACT_APP_DEBUG=='1';
const SECURE_DEBUG = process.env.REACT_APP_SECURE_DEBUG=='1';

async function post<T=any>(endpoint: string, data?: any) : Promise<APIResponse<T>>{
	var options = {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	if(data instanceof FormData){
		options.headers['Content-Type'] = 'multipart/form-data';
	}

	try{
		var ENDPOINT = `${ROOT_URL}/${endpoint}`;
		if(DEBUG) console.log("POST "+ENDPOINT);
		var res = await axios.post(ENDPOINT, data, options);
		if(DEBUG) console.log(` => Response: ${(res.headers['content-length']/1024).toFixed(2)} KB`);
		return res.data as APIResponse<T>;
	}catch(err){
		if(DEBUG) console.error(err);
		return {
			error: true, 
			message: 'Hubo un error inesperado (APIP-LCL-1)',
			code: 'APIP-LCL-1',
		}
	}
};

var getPayment = (hash: string)=>{
	return post<PaymentData>('payment/get', { hash });
}

var sendCharge = (hash: string)=>{
	return post<{ charging: boolean, paid: boolean, cancelled: boolean }>('payment/charge', { hash });
}

var getPaymentStatus = (token: string)=>{
	return post<PaymentSocketData>('payment/status', { token });
}

var getPaymentRequest = (hash: string)=>{
	return post('request/get', { hash });
}

var createRequestPayment = (hash: string, card_token: string)=>{
	return post<{
		redirect: string
	}>('request/create', { hash, card_token });
}

var getRequestPayment = (hash: string)=>{
	return post('request/payment/get', { hash });
}

export default {
	DEBUG,
	SECURE_DEBUG,
	createRequestPayment,
	getPayment,
	getPaymentRequest,
	getPaymentStatus,
	getRequestPayment,
	sendCharge,
}